import { BrowserNetworkError, RequestTimeoutError } from 'Lib/errors';

export type FetchOptions = {
  qs?: Record<string, string>;
  shouldMeasurePerf?: boolean;
  shouldSupportShortVideo?: boolean;
} & RequestInit;

function fetch(url: string, options: FetchOptions = {}, timeout: number = 30000) {
  const urlWithQuery = options.qs ? `${url}?${new URLSearchParams(options.qs).toString()}` : url;
  let controller;
  const fetchOptions = options;
  if (window.AbortController) {
    controller = new AbortController();
    fetchOptions.signal = controller.signal;
  }
  return Promise.race([
    new Promise((resolve, reject) => {
      global
        .fetch(urlWithQuery, fetchOptions)
        .then((res) => resolve(res)) // correct response regardless of response code, we will handle later
        .catch((e) => {
          // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Checking_that_the_fetch_was_successful
          // https://github.com/github/fetch/issues/201#issuecomment-403010358
          // https://github.com/github/fetch/issues/201#issuecomment-308213104
          const isNetworkError = e instanceof TypeError;
          reject(isNetworkError ? new BrowserNetworkError() : e);
        });
    }),
    new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(new RequestTimeoutError());
        if (controller) {
          controller.abort();
        }
      }, timeout);
    }),
  ]) as Promise<Response>;
}

export default fetch;
